export const arr1 = [
  { text: 'Хочешь увидеть, как выглядит музыка?' },
  { text: 'Тогда сыграй на музыкальных инструментах, и ты увидишь графическое отображение каждой ноты сыгранных мелодий - их спектрограммы.' },
  // { text: 'А я помогу.' },
  { text: 'Задание: сыграй мелодии на музыкальных инструментах, нажимая на подсвеченные клавиши.', buttonTitle: 'Сыграть' },
]

export const arr2 = [
  { text: 'Каждая нота имеет свой рисунок, свою спектрограмму.' },
  { text: 'Чем ярче рисунок, тем громче она звучала.' },
  { text: 'Чем больше световых полос - тем больше частот прозвучало.' },
  { text: 'А ещё: ты только что сыграл одну и ту же мелодию, только на разных инструментах.', buttonTitle: 'Продолжить' },
]

export const arr3 = [
  { text: 'Так как музыка может быть записана с разным качеством, то и изображения могут отличаться. Поэтому компьютер смотрит не на все изображение, а лишь на самые яркие точки. Давай поможем компьютеру увидеть их!' },
  { text: 'Задание: отметь самые яркие точки спектрограммы. В каждом столбике, кроме первого, не более 2 ключевых точек.', buttonTitle: 'Продолжить' },
]

export const arr4 = [
  { text: 'Смотри, насколько похожи получились созвездия! Получается, это одна и та же мелодия!' },
  { text: 'А давай узнаем автора этой музыки?', buttonTitle: 'Продолжить' },
]

export const hint = [
  { text: 'В каждом столбце этой мелодии только одна самая яркая точка.' },
]

export const task1 = [
  { text: 'Задание: сыграй мелодии на музыкальных инструментах, нажимая на подсвеченные клавиши.' },
]

export const task02 = [
  { text: 'Задание: сыграй мелодии на музыкальных инструментах, нажимая на подсвеченные клавиши.', buttonTitle: 'Продолжить', key: 'xylo' },
]

export const task2 = [
  { text: 'Задание: отметь самые яркие точки спектрограммы. В каждом столбике, кроме первого, не более 2 ключевых точек.' },
]
